export default {
  ADMINISTRATOR: {
    title: "Amministratore",
    value: "ADMINISTRATOR",
  },
  CALL_CENTER_ADMINISTRATOR: {
    title: "Amministratore di call center",
    value: "CALL_CENTER_ADMINISTRATOR",
  },
  CALL_CENTER_OPERATOR: {
    title: "Operatore di call center",
    value: "CALL_CENTER_OPERATOR",
  },
  CALL_CENTER_TEAM_LEADER: {
    title: "Team leader",
    value: "CALL_CENTER_TEAM_LEADER",
  },
  WAREHOUSE_OPERATOR: {
    title: "Operatore di magazzino",
    value: "WAREHOUSE_OPERATOR",
  },
  NETWORK: {
    title: "Network",
    value: "NETWORK",
  },
  CUSTOMER_CARE: {
    title: "Customer care",
    value: "CUSTOMER_CARE",
  },
};
